import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap';

export default class ImageProgressBar extends Component {
    static propTypes = {
        imageInfo: PropTypes.shape({
            uploadPct: PropTypes.number,
            poppingPct: PropTypes.number,
        }),
    };

    render() {
        const {imageInfo} = this.props;
        if (!imageInfo || !('uploadPct' in imageInfo)) {
            return false;
        }

        const uploadPct = Math.round(imageInfo.uploadPct || 0);
        const poppingPct = Math.round(imageInfo.poppingPct || 0);

        const uploadLabel = <span style={{position: 'absolute', width: '50%', display: 'block', color: 'black', borderRight: '1px solid #cccccc'}}>{`${uploadPct}%`}</span>;
        const poppingLabel = <span style={{position: 'absolute', width: '50%', display: 'block', color: 'black', left: '50%'}}>{`${poppingPct}%`}</span>;

        return (
            <ProgressBar>
                <ProgressBar active={uploadPct < 100} bsStyle="warning" now={uploadPct / 2} key={1} label={uploadLabel} title="Uploading"/>
                <ProgressBar active bsStyle="success" now={poppingPct / 2} key={2} label={poppingLabel} title="Popping"/>
            </ProgressBar>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ImageProgressBar.js